import { render } from "./Others12Charts.vue?vue&type=template&id=701c4dc0&scoped=true"
import script from "./Others12Charts.vue?vue&type=script&lang=js"
export * from "./Others12Charts.vue?vue&type=script&lang=js"

import "./Others12Charts.vue?vue&type=style&index=0&id=701c4dc0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701c4dc0"]])

export default __exports__